import { itx } from "../../../src/translationItx/itx";
import type { ReactNode } from "react";
import c1_state from "../model/C1_State";

export type C1_SerializedPlanSvg = {
  markup: string;
  width: number;
  height: number;
};

const exportedStyleProperties = [
  "fill",
  "fill-opacity",
  "stroke",
  "stroke-width",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-dasharray",
  "stroke-opacity",
  "opacity",
  "font-family",
  "font-size",
  "font-style",
  "font-weight",
  "text-anchor",
  "dominant-baseline",
] as const;

export function serializeC1PlanSvg(svg: SVGSVGElement): C1_SerializedPlanSvg {
  const clone = svg.cloneNode(true) as SVGSVGElement;
  const sourceElements = [svg, ...svg.querySelectorAll("*")];
  const clonedElements = [clone, ...clone.querySelectorAll("*")];

  sourceElements.forEach((source, index) => {
    const target = clonedElements[index];
    if (!(target instanceof SVGElement)) return;
    const computed = window.getComputedStyle(source);
    exportedStyleProperties.forEach((property) => {
      if (target.hasAttribute(property) || target.style.getPropertyValue(property)) return;
      const value = computed.getPropertyValue(property);
      if (value) target.style.setProperty(property, value);
    });
  });

  clone
    .querySelectorAll("foreignObject, [data-c1-export-exclude], .C1_svgOpeningHitArea, .C1_dimHit, .C1_svgLightHitArea")
    .forEach((element) => element.remove());
  clone.removeAttribute("aria-label");
  clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");

  const viewBox = svg.viewBox.baseVal;
  clone.setAttribute("width", String(viewBox.width));
  clone.setAttribute("height", String(viewBox.height));
  return {
    markup: new XMLSerializer().serializeToString(clone),
    width: viewBox.width || svg.clientWidth,
    height: viewBox.height || svg.clientHeight,
  };
}

export function C1_PlanSvg({ children }: { children: ReactNode }) {
  return (
    <svg
      className="C1_planSvg"
      width={c1_state.canvasWidth}
      height={c1_state.canvasHeight}
      viewBox={`0 0 ${c1_state.svgCanvasWidth} ${c1_state.svgCanvasHeight}`}
      xmlns="http://www.w3.org/2000/svg"
      aria-label={itx("c1.ui.SVG_Zeichnungsebene", "SVG-Zeichnungsebene")}
    >
      {children}
    </svg>
  );
}
